package com.friendly.framework.graph

enum class AppType {
    E_COMMERCE, BUSINESS, FRIENDLY
}
